import { Component, EventEmitter, Input, Output } from '@angular/core';

import { IChapter } from 'rev-shared/media/videoChapter/IChapter';

import styles from './VideoChapters.module.less';

@Component({
	selector: 'video-chapters-container',
	host: {
		'[class]': 'styles.wrapper'
	},
	template: `
		<div
			*ngFor="let chapter of video.chapterInfo.chapters; let i = index"
			[ngClass]="styles.chapterContainer"
		>
			<button
				type="button"
				class="btn btn-transparent"
				[ngClass]="[styles.chapter, chapter === video.chapterInfo.currentChapter ? styles.currentChapter : '']"
				(click)="clickChapter(chapter, i)"
			>
				<div [ngClass]="styles.chapterTitle">
					<span [ngClass]="styles.chapterIndex">{{ 'ChapterNumber' | translate : { '0': i + 1  } }}</span>
					<span>&nbsp;-&nbsp;{{ chapter.title }}</span>
				</div>
				<div [ngClass]="styles.chapterTime">{{ chapter.time | vbTimespan }}</div>
			</button>
		</div>
	`
})

export class VideoChaptersContainerComponent {
	@Input() public video: any;
	@Output() public onChapterClick: EventEmitter<any> = new EventEmitter();

	public readonly styles = styles;

	public clickChapter(chapter: IChapter, index: number): void {
		this.video.chapterInfo.focusChapter(index);

		this.onChapterClick.emit({
			time: chapter.time
		});
	}
}
